import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  adminStoreList: [],
  adminStoreInfo: {},
  count: {},
  transaction: {},
  sales: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
